import * as React from "react";
import PaymentLayout from "../layout/paymentLayout";
import PricingCardContainer from "./priceCard";

const withLayout = (Component: React.Element) => function LayoutWrapper(props: any) {
    return (
        <PaymentLayout>
            <Component {...props} />
        </PaymentLayout>
    );
};

export default {
    PricingCard: withLayout(PricingCardContainer),
};